import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareCapacityCustomEmbedRoute } from '@atlassian/jira-router-routes-software-capacity-routes/src/softwareCapacityCustomEmbedRoute.tsx';
import { CapacityEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { capacityRouteEntry } from './common/capacityRouteEntry.tsx';

export const softwareCapacityCustomEmbedRouteEntry = createEntry(
	softwareCapacityCustomEmbedRoute,
	() => ({
		group: 'software',
		skeleton: CapacityEmbedSkeleton,
		component: CapacityEmbedSkeleton,

		entryPoint() {
			return capacityRouteEntry;
		},

		layout: chromelessLayout,
		resources: [themePreferenceResource],
		ufoName: 'next-gen-capacity-embed',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-software-capacity-entries/src/softwareCapacityCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'softwareCapacityCustomEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
